import { useRouter } from 'next/router'
import { useCallback, useEffect } from 'react'

import { useRedirectCustomerPortalMutation } from '~/redux/apis/payment-api'
import ROUTES from '~/shared/constants/routes.const'

export function useRedirectToCustomerPortal(): (redirectUrl?: string) => Promise<void> {
  const [redirectStripeCustomerPortal, { data: response, isLoading, isSuccess, error, isError }] =
    useRedirectCustomerPortalMutation()
  const router = useRouter()
  useEffect(() => {
    if (isLoading) return

    if (isError && error) {
      if (error?.status === 404) {
        router.push(ROUTES.SUBSCRIPTION_PAGE)
      }
    }

    if (response) {
      router.replace(response?.redirectUrl)
    }
  }, [isLoading, isSuccess, router, isError, error, response])

  const redirect = useCallback(
    async (redirectUrl?: string): Promise<void> => {
      await redirectStripeCustomerPortal({
        redirectUrl: `${window.location.origin}${redirectUrl ?? router.asPath}`,
      }).unwrap()
    },
    [redirectStripeCustomerPortal, router],
  )

  return redirect
}
